import styled, { css } from 'styled-components';
import { spaceFor } from 'components/space_helper';

const baseHeader = css`
  align-items: center;
  color: ${p => p.theme.colors.black};
  display: flex;
  font-weight: ${p => p.theme.fontWeight.heavy};
  justify-content: space-between;
  margin: 0;
  flex-shrink: 0;
  line-height: 1;
  margin-bottom: ${p => spaceFor('stack', p)};
`;

export const H1 = styled.h1`
  ${baseHeader};
  font-size: var(--font-size-xlarge);
`;

export const H2 = styled.h2`
  ${baseHeader};
  font-size: 20px;
`;

export const H3 = styled.h3`
  ${baseHeader};
  font-size: var(--font-size-medium);
`;

export const H4 = styled.h4`
  ${baseHeader};
  font-size: var(--font-size-base);
  font-weight: ${p => p.theme.fontWeight.medium};
`;

export const H5 = styled.h5`
  ${baseHeader};
  font-size: var(--font-size-reduced);
  font-weight: ${p => p.theme.fontWeight.medium};
`;
